export const Divider = {
  baseStyle: {
    borderColor: "textMuted",
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}
